import React from 'react'
import { Button } from 'src/components'
import { WeightValidationResult } from 'src/utils/weightValidation'
import { useStyles } from '../ConfirmationModal/styles'

interface WeightWarningModalProps {
  open: boolean
  validationResult: WeightValidationResult | null
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const WeightWarningModal: React.FC<WeightWarningModalProps> = ({
  open,
  isLoading,
  validationResult,
  onConfirm,
  onCancel
}) => {
  const styles = useStyles()

  if (!open || !validationResult || !validationResult.details) {
    return null
  }

  const { ageInMonths, minLimit, maxLimit } = validationResult.details
  const isBlocked = validationResult.status === 'blocked'

  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>Atenção</h2>
        <p className={styles.message}>
          {isBlocked ? (
            validationResult.message || 'O peso informado está fora dos limites permitidos.'
          ) : (
            <>
              Com <strong>{ageInMonths} meses</strong> o peso deve estar entre <strong>{minLimit}kg</strong> e{' '}
              <strong>{maxLimit}kg</strong>
            </>
          )}
        </p>
        <div className={styles.buttons}>
          <Button disabled={isLoading} onClick={onCancel} outlined>
            {'Cancelar'}
          </Button>
          {!isBlocked && (
            <Button disabled={isLoading} onClick={onConfirm} isLoading={isLoading}>
              Continuar
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
